import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { VehicleModelService } from '../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import {NgxMaskDirective} from 'ngx-mask';

@Component({
  selector: 'vehicle-model-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    NgxMaskDirective,
  ],
  templateUrl: './vehicle-model-create.component.html',
  styleUrl: './vehicle-model-create.component.scss',
  providers: [VehicleModelService, VehicleTypeService],
  standalone: true,
})
export class VehicleModelCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private vehicleModelService: VehicleModelService,
    private vehicleTpeService: VehicleTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listType: any[] = []

  ngOnInit(): void {
    // this.listTypeVehicle()
    this.createForm()
  }

  // listTypeVehicle() {
  //   this.vehicleTpeService.listVehicleType().subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.listType = response.data
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => {},
  //   })
  // }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.vehicleModelService.createManufacturer(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      nome: this.form.controls['name'].value,
      contato: this.form.controls['contact'].value,
      email: this.form.controls['email'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      contact: ['', [Validators.required]],
      email: ['', [Validators.required]],
    })
  }
}
